
import React from 'react';
import Layout from '@/components/Layout/Layout';
import AreaConverter from '@/components/UnitConverter/AreaConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const AreaConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Area Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of area, from square meters to acres and more.
          </p>
        </div>
        
        <div className="mb-8">
          <AreaConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Area Converter</h2>
          <p>
            Our area converter tool helps you convert between different units of area measurement. 
            Whether you're working in real estate, construction, agriculture, or other fields that 
            require area calculations, this converter provides accurate and quick results.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Area Unit Conversions</h3>
          <p>
            Some of the most frequently used area conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between square meters and square feet (construction)</li>
            <li>Converting acres to hectares (agriculture and real estate)</li>
            <li>Converting square kilometers to square miles (geography)</li>
            <li>Converting between different land measurement units</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Area Converter</h3>
          <p>
            Using our area converter is simple:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the unit you're converting from in the dropdown</li>
            <li>Select the unit you want to convert to in the "To" dropdown</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            The area converter supports a wide range of units, including square millimeters, 
            square centimeters, square meters, hectares, square kilometers, square inches, 
            square feet, square yards, acres, square miles, and more specialized units. 
            Whether you're calculating land area or material requirements, our converter 
            has you covered.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AreaConverterPage;
